import {
  SET_TITLE, SET_DASHBOARD, SET_MESSAGE,
  SET_CACHE_FILTER, SET_CURRENCY, SET_DEFAULT_CURRENCY,
  SET_TEMP_CURRENCY
  // ADD_DASHBOARD, UPDATE_DASHBOARD, DELETE_DASHBOARD
} from '../actions/site';

const initialState = {
  title: '',
  key: '',
  dashboards: [],
  cacheFilters: [],
  message: null,
  currency: null, // {default_val: 'MYR', value: ['MYR'] }
  tempCurrency: null
};

const site = (state = initialState, action) => {
  switch (action.type) {
    case SET_TITLE:
      return {
        ...state,
        title: action.payload.title,
        key: action.payload.key || ''
      };

    case SET_DASHBOARD:
      return { ...state, dashboards: action.payload };

    case SET_MESSAGE:
      return { ...state, message: action.payload };

    case SET_CURRENCY:
      return { ...state, currency: action.payload };

    case SET_DEFAULT_CURRENCY:
      return {
        ...state,
        currency: {
          ...state.currency,
          default_val: action.payload
        }
      };

    case SET_TEMP_CURRENCY:
      return { ...state, tempCurrency: action.payload };

    case SET_CACHE_FILTER:
      return {
        ...state,
        cacheFilters: [...state.cacheFilters]
      };

      // case ADD_DASHBOARD:
      //   return {
      //     ...state,
      //     dashboards: [...state.dashboards,
      //       action.payload
      //     ]
      //   };

      // case UPDATE_DASHBOARD:
      //   return {
      //     ...state,
      //     dashboards: [...state.dashboards.map((d) => (
      //       d.id === action.payload.id ? action.payload.dashboard : d
      //     ))
      //     ]
      //   };

      // case DELETE_DASHBOARD:
      //   return {
      //     ...state,
      //     dashboards: [...state.dashboards.filter((d) => d.id === action.payload.id)]
      //   };

    default:
      return state;
  }
};

export default site;
